import { Box } from '@mui/material';
import React from 'react';
import { AnswerElementDefaultProps } from '../../../../types/types';
import { findValueInConfig } from '../../../../util/util';
import { CID_RHION } from '../../../../types/constants';
import { getCustomizingID } from '../../../../util/util';
import stoererIphoneGross from '../../../../assets/images/stoerer_iphone_groß_20260724-04.png';
import dipoIphoneStoerer from '../../../../assets/images/DiPo_Iphone_Stoerer.png';
interface AnswerElementGewinnspiel2026Props extends AnswerElementDefaultProps {

}

interface AnswerElementGewinnspiel2026State {
    gewinnspiel2026Aktiv: boolean,
}


class AnswerElementGewinnspiel2026 extends React.Component<AnswerElementGewinnspiel2026Props, AnswerElementGewinnspiel2026State> {


    constructor(props: any) {
        super(props);
        //let gewinnspiel2026Aktiv = this.findValueInConfig(TemplateElementConfigKey[TemplateElementConfigKey.GEWINNSPIEL_2026_AKTIV]);
        this.state = { gewinnspiel2026Aktiv: this.checkGewinnspiel2026Aktiv() };

        //this.setState({gewinnspiel2026Aktiv: gewinnspiel2026Aktiv});

    }

    /**
     * Prüft anhand der Umgebungsvariablen REACT_APP_GEWINNSPIEL2026_AB und
     * REACT_APP_GEWINNSPIEL2026_BIS, ob das Gewinnspiel aktuell aktiv ist.
     */
    checkGewinnspiel2026Aktiv(): boolean {
        const ab = process.env.REACT_APP_GEWINNSPIEL2026_AB;
        const bis = process.env.REACT_APP_GEWINNSPIEL2026_BIS;
        if (!ab || !bis) {
            return false;
        }
        const now = new Date();
        const dateAb = new Date(ab);
        const dateBis = new Date(bis);
        return now >= dateAb && now <= dateBis;
    }

    render() {
        if (this.state.gewinnspiel2026Aktiv) {
            if (getCustomizingID(window.location.href) === CID_RHION) {
                return (
                    <div className='control-wrapper'>
                        <Box display="flex" alignItems="center" gap={2}>
                            <img src={dipoIphoneStoerer} alt="Gewinnspiel iPhone" style={{ height: '150px' }} />
                            <p>Nutzen Sie die Chance auf ein neues Apple iPhone 17 Pro oder Apple AirPods 3.<br />
                                Die Teilnahmeinformationen zum Gewinnspiel finden Sie <a href="https://rhion.digital/fileadmin/redaktion/DOWNLOADS/Digitales_Postfach/Teilnahmebedingungen_DiPo_Gewinnspiel.pdf" target="_blank" rel="noreferrer">hier</a>.</p>
                        </Box>
                    </div>
                );
            } else {
                return (
                    <div className='control-wrapper'>
                         <Box display="flex" alignItems="center" gap={2}>
                            <img src={stoererIphoneGross} alt="Gewinnspiel iPhone" style={{ height: '150px' }}/>
                             <p>Jetzt anmelden und mit etwas Glück gewinnen!<br />
                                    Die Teilnahmeinformationen zum Gewinnspiel finden Sie <a href="https://payload.rheinland-versicherungen.de/assets/documents/Teilnahmebedingungen_DiPo_Gewinnspiel.pdf" target="_blank" rel="noreferrer" >hier</a>.</p>
                        </Box>
                    </div>
                );
            }

        } else {
            return (
                <div className='control-wrapper'>
                    
                    <> </>
                </div>

            );
        }
    }

    /**
     * Sucht einen Wert zum übergebenen Key in der Config des TemplateElements.
     * 
     * @param key 
     */
    findValueInConfig(key: string): string {
        return findValueInConfig(this.props.el, key);
    }




}
export default AnswerElementGewinnspiel2026